import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setRegPage, getGuestInRoom, currentWidget, setDeviceConfigFailed, setShowCustomPopup, setFailScreen } from '../../../action/action'
import { guestDetails, sendAnalytics, setWarningPopup } from '../../../action/homeAction'
import { getGuestRequestList,setGuestRequestList } from '../../../action/guestRequest'
import { CMSPath, CLICKED, EXIT, globalSalt, globalIV } from '../../../config/constant'
import OrderRequest from './orderRequest'
import { setSelectedList, setGoHome, setLoginRequired } from '../../action/homeAction'
import { scrollToTop } from '../../../JS/scrollToTop'
import { guestRequestColorConfig, clearConfig } from '../../JS/colorConfig'
import $ from 'jquery';
import { dynamicHeight } from '../../JS/listItemHeightFix';
import Loader from '../../UI/loader';
import {withTranslation} from "react-i18next";
import { calculateTimeDifference, getDefaultAnalyticsLabel, makeStringStrictlyCapitalize } from '../../JS/utility'
import LoginRequiredOverlay from '../../UI/loginRequiredOverlay'
import { wipeGuestData } from '../../../JS/wipeGuestData'
import { AesUtil } from '../../../JS/AesUtil'
import { setHCommerceSavedOrders } from '../../../action/hcommerce'
import { getCdnUrl } from '../../../config/config'



class GuestRequest extends Component {

    constructor(props){
        super(props);
        this.timeoutTimer = null
        this.state = {
            showLoader:true,
            showGuestRequestData: true,
            sendRequestInProg:false,
            widgetLaunchTime: new Date,
            widgetName: this.props.currentWidgets.displayName,
        }
        this.aesUtil = new AesUtil(128, 1000);
    }

    componentDidMount() {
        // guestRequestColorConfig(this.props.menuColor)
        console.log('this.props.guestDetail',this.props.guestDetail)
        scrollToTop()
        let SessionToken = localStorage.getItem("GuestJourneySessionToken");
        let room = localStorage.getItem("room");

        let guestDetails = {}

        if(localStorage.getItem("Set_Current_Logged_In_Guest_Details")){
            guestDetails = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))[0];
        } else if( this.props.enableQPSAfterPreCheckIn && (localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA"))) {
            let preCheckedInData = JSON.parse(this.aesUtil.decrypt(globalSalt, globalIV, "1234567891234567", (localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA"))));
            if(preCheckedInData.reservationNumber){
                guestDetails = preCheckedInData;
            }
        }


        if ( (!room || room == "null") && Object.keys(guestDetails).length == 0) {
                if(process.env.REACT_APP_INROOMTAB == "true") {
                    this.props.setLoginRequired(true)
                } else {
                    this.props.setRegPage(true);
                }
                return
        } else {
            // if(!navigator.onLine){
            //     this.props.setDeviceConfigFailed(true);
            // }
            console.log('this.props.currentWidgets.storeSku',this.props.currentWidgets.storeSku)
            // this.props.getGuestInRoom(this.props.guestDetail);
            this.props.getGuestRequestList(guestDetails, this.props.currentWidgets.storeSku,(status, msg) => {
                if(status){
                    // this.timeoutTimer = window.setTimeout(
                    //     () => {
                            this.setState({showLoader:false})
                        // }, 3000
                    // )
                }else{
                    this.setState({showLoader:false})
                    this.props.setFailScreen(true, msg, "We are not not able to get the data for service request, please check your internet connection or try again", true)
                    this.props.setGoHome(true);
                }
            });
        }
        dynamicHeight();

        // Send Analytics
            let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
            this.props.sendAnalytics(
                guestDetails, 
                this.props.currentWidgets.displayName, 
                CLICKED, 
                {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget"}, 
                0, 
                this.props.guestIsLoggedIn
            );
        // 

    }

    componentWillUnmount() {
        // clearConfig(this.props.menuColor)

        // Send Analytics
        if(this.props.guestIsLoggedIn){
            console.log("sending analytics")
            let widgetCloseTime = new Date
            let duration = calculateTimeDifference(this.state.widgetLaunchTime, widgetCloseTime, 'second')
            let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
            this.props.sendAnalytics(
                this.props.guestDetail, 
                this.state.widgetName, 
                EXIT, 
                {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "duration": duration}, 
                0, 
                this.props.guestIsLoggedIn
            );
        }
        // 
        $("body").removeClass("overlay-cast");
        // this.props.setSelectedList([]);
        // this.props.setGuestRequestList([]);
        // this.props.currentWidget({});
    }

    componentDidUpdate(preProp) {
        // if (preProp.guestRequestList !== this.props.guestRequestList)
        // guestRequestColorConfig(this.props.menuColor)
        dynamicHeight();

        if(this.props.selectedList && this.props.selectedList.length == 0 && !this.state.showGuestRequestData){
            this.setState({showGuestRequestData: true})
        }
    }

    addToSelectList = (id) => {
        //console.log("addToSelectList");
        let selectedList = [...this.props.selectedList]
        if (selectedList.indexOf(id) !== -1) {
            selectedList.splice(selectedList.indexOf(id), 1);
        } else {
            selectedList.push(id);
        }
        //this.setState({ selectedList: selectedList });
        this.props.setSelectedList(selectedList);
        console.log('selectedList',selectedList)
    }

    goBack = () => {

        if(!this.state.showGuestRequestData){
            this.setState({showGuestRequestData: true})
            return;
        }

        if(this.props.selectedList && this.props.selectedList.length > 0){
            // this.props.setWarningPopup({show: true, msg: "You have requests pending. Are you sure you want to exit?"})
            
            this.props.setShowCustomPopup(true,{
                htmlTagId:"items-in-cart",
                title: "Cancel request",
                subtitle:"",
                heading:"Are you sure you want to cancel?",
                subHeading:"There are items in your cart that will be removed when you exit.",
                primaryButtonText:"continue with request",
                secondaryButtonText:"Cancel request",
                secondaryButtonStyleIsUnderline:false,
                primaryOnClick:()=>{ this.props.setShowCustomPopup(false,{});
                
                },

                secondaryOnClick:()=>{
                    this.props.setShowCustomPopup(false,{});
                    this.props.setGoHome(true);
                    this.props.setHCommerceSavedOrders([]);
                    this.props.setSelectedList([]); 
                    },

                closeOnClick:()=>{ this.props.setShowCustomPopup(false,{}); }
        })  

        
        }  else {
            this.props.setGoHome(true);
        }
    }

    GuestReqItem = (iterator={},imagePath="")=>{

            return (
                <a className={
                    this.props.selectedList.length > 0 &&
                        this.props.selectedList.indexOf(iterator.serviceRequestId) !== -1 ?
                        "tile-sm thumbnails tile-container selected" : "tile-sm thumbnails tile-container"
                }
                   
                    onClick={() => { this.addToSelectList(iterator.serviceRequestId) }}
                >
                    <img src={imagePath}/>
                    <div class="thumb-text" style={{ color: "inherit" }}>
                        <p class="thumb-heading" style={{ color: "inherit" }} dangerouslySetInnerHTML={{__html: `${iterator.name}`}}></p>
                        <p class="thumb-subheading" style={{ color: "inherit" }} dangerouslySetInnerHTML={{__html: `${iterator.description}`}}></p>
                    </div>
                </a>
            )
    }

    render() {
        let imagePath
        const { t } = this.props
        return (
            <div>
                <header className={`inner-pages w-footer ${!this.state.showGuestRequestData && 'check-out'}`} id="guestRequest"
                    style={{
                        background: this.props.menuColor,//`url('${this.props.currentWidgets.widgetHeaderImageUrl ? CMSPath + this.props.currentWidgets.widgetHeaderImageUrl : this.props.currentWidgets.compImage}')center center no-repeat`,
                        backgroundSize: "cover"
                    }}
                >
                    <a onClick={this.goBack} class="button-back"></a>
                    <div class="heading align-center" >
                        <div class="splash-brand">
                            <img src={getCdnUrl(CMSPath, this.props.logo)} />
                        </div>
                        {/* <p class="bold">{this.props.currentWidgets.displayName}</p> */}
                        {/* <p dangerouslySetInnerHTML={{__html: this.props.guestRequestWidgetData.description}} ></p> */}
                        {/* <p>Some description goes here and it can go on for at least three lines if needed but should not exceed that.</p> */}
                    </div>
                </header>
                { this.state.showGuestRequestData && <section class="widgets">
                    {/* <div class="widgets user-info">
                        <div class="user-stay tile tile-container custom-select secondary">
                            <select>
                                <option selected="">Top Level Category (3)</option>
                                <option>Room Services</option>
                                <option>Conceirge</option>
                                <option>Supplies</option>
                                <option>Repairs</option>
                            </select>
                        </div>
                    </div> */}
                    <div class="widget-header">
                        { this.props.currentWidgets.widgetHeaderImageUrl && 
                            <div class="widget-header-img">
                                <img src={`${CMSPath}${this.props.currentWidgets.widgetHeaderImageUrl}`} alt={this.props.currentWidgets.displayName} />
                            </div>
                        }
                        <div class="widget-header-title">{this.props.currentWidgets.displayName}</div>
                        <div class="widget-header-desc" dangerouslySetInnerHTML={{__html: this.props.guestRequestWidgetData.description}}></div>
                    </div>
                    <div class="widgets">
                        <div class="row margin-bottom-2">
                            <div class="row">
                                <div class="col col-2 menu-items guest-request">
                                    {this.props.groupedGuestRequestData 
                                          ?
                                          this.props.groupedGuestRequestData.length > 0 &&
                                          this.props.groupedGuestRequestData.map((group, index) => {
                                              return (  <React.Fragment key={index}>
                                         
                                                  <div className="group-title">{makeStringStrictlyCapitalize(group.name)}</div> 

                                                  {group.requestMaster.length > 0 &&
                                                  group.requestMaster.map((item, idx) => {
                                                      const imagePath = encodeURI(`${CMSPath}${this.props.imageBaseUrl}${item.imageName}`);

                                                      return (
                                                          this.GuestReqItem(item,imagePath)
                                               )
                                                  })}
                                        
                                              </React.Fragment>
                                              )
                                          })
                                          :
                                          this.props.guestRequestList.length > 0 && this.props.guestRequestList.map((iterator,index) => {
                                                imagePath = encodeURI(`${CMSPath}${this.props.imageBaseUrl}${iterator.imageName}`)
                                                return (<React.Fragment key={index}>
                                                           {this.GuestReqItem(iterator,imagePath)}
                                                           </React.Fragment>
                                                )
                                            })
                                              
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </section>}
                {(this.props.selectedList && this.props.selectedList.length > 0) &&<OrderRequest showGuestRequestDataState={this.state.showGuestRequestData} handleshowGuestRequestData={(bool) => this.setState({showGuestRequestData:bool})} setSendRequestInProg={(bool) => this.setState({sendRequestInProg:bool})}/>}
                {(this.state.showLoader || this.state.sendRequestInProg) && <Loader displayMsg={this.state.sendRequestInProg ? "Sending data" : null}/>}
            </div >
        )
    }
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        enableQPSAfterPreCheckIn: state.store.home.currentDuration && state.store.home.currentDuration.configs && state.store.home.currentDuration.configs.enableQPSAfterPreCheckIn ? state.store.home.currentDuration.configs.enableQPSAfterPreCheckIn : false,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        guestRequestWidgetData: state.store.guestRequest.guestRequestOtherData ? state.store.guestRequest.guestRequestOtherData : {},
        guestRequestList: state.store.guestRequest.guestRequestList,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        imageBaseUrl: state.store.guestRequest.guestRequestOtherData ?
            state.store.guestRequest.guestRequestOtherData.imageBaseUrl : null,
        menuColor: state.store.home.MenuColor,
        displayName: state.store.sideNavBar.currentWidget.displayName,
        currentHomePage: state.store2.currentHomePage,
        selectedList: state.store2.selectedList,
        showLoginRequired: state.store.showLoginRequired,
        groupedGuestRequestData: state.store.guestRequest.groupedGuestRequestData,
    }
}
export default connect(
    mapStateToProps,
    {
        setRegPage,
        setWarningPopup,
        getGuestInRoom,
        getGuestRequestList,
        setSelectedList,
        currentWidget,
        setGoHome,
        setDeviceConfigFailed,
        setGuestRequestList,
        sendAnalytics,
        guestDetails,
        setLoginRequired,
        setShowCustomPopup,
        setHCommerceSavedOrders,
         setFailScreen
       
        // getItemType,
        // changePage
    }
)(withTranslation('translations')(GuestRequest));